import React, { useEffect } from 'react';
import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import styles from './styles.scss';
import Overview from '../shared/Overview';
import {
  analyticsDataProps,
  cartDataProps,
  isTrialProps,
  trialInfoProps
} from '../../shared/prop-types';
import Card from '../shared/Card';
import Inset from '../shared/Inset';
import Pricing from '../shared/Pricing';
import Footnote from '../shared/Footnote';
import { I18nPrefix } from '../../shared/constants';

const SummaryStudents = ({ cartData, isTrial, trialInfo, analyticsData }) => {
  useEffect(() => {
    const trackProps = {
      category: 'subscriptions',
      page: 'student_plan_checkout',
      properties: {
        ...analyticsData,
        subscription_type: isTrial ? 'trial' : 'organic'
      }
    };
    trackV2({ ...trackProps, action: 'screen_enter' });
    return () => {
      trackV2({ ...trackProps, action: 'screen_exit' });
    };
  }, [analyticsData, isTrial]);

  return (
    <div className={styles.checkoutSummary}>
      <Card>
        <Inset>
          <Overview
            cartData={cartData}
            isTrial={isTrial}
            trialInfo={trialInfo}
          />
        </Inset>
        <Inset transparent={isTrial}>
          <Pricing
            isPrimary={true}
            label={I18n.t(
              `${I18nPrefix}.summary.students.billing.billed_today`
            )}
            cartData={cartData}
            showFootnote={!isTrial}
          />
        </Inset>
        {isTrial && (
          <Inset>
            <Pricing
              isPrimary={false}
              label={I18n.t(
                `${I18nPrefix}.summary.students.billing.billed_after_trial`
              )}
              cartData={cartData}
              showFootnote={true}
            />
          </Inset>
        )}
        <Inset>
          <Footnote />
        </Inset>
      </Card>
    </div>
  );
};

SummaryStudents.propTypes = {
  cartData: cartDataProps.isRequired,
  trialInfo: trialInfoProps,
  isTrial: isTrialProps.isRequired,
  analyticsData: analyticsDataProps.isRequired
};

SummaryStudents.defaultProps = {
  trialInfo: null
};

export default SummaryStudents;
